import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    buttonClassName,
    labelClassName,
} from '@archipro-design/aria';
import type { CTAHeaderType } from './PageDetailHeaderCTA';
import { svgIconClassName } from '@archipro-design/icons';

export const LinkButton: StyleRule = ({ theme }) => ({
    textDecoration: 'none',
    marginBottom: 'auto',
    [theme.screen.tablet]: {
        marginBottom: 'unset',
    },
    lineHeight: pxToRem(14),
    color: theme.siteVariables.colors.charcoal['000'],
    [`& .${svgIconClassName}`]: {
        fill: theme.siteVariables.colors.charcoal['000'],
    },

    [`& .${buttonClassName} `]: {
        textDecoration: 'none',
        [`&.${labelClassName}`]: {
            color: theme.siteVariables.colors.charcoal['000'],
        },
        [`& .${svgIconClassName}`]: {
            fill: theme.siteVariables.colors.charcoal['000'],
        },
    },
    ':hover': {
        [`& .${buttonClassName} `]: {
            [`&.${labelClassName}`]: {
                color: theme.siteVariables.colors.charcoal['000'],
            },
            [`& .${svgIconClassName}`]: {
                fill: theme.siteVariables.colors.charcoal['000'],
            },
        },
    },

    '& > span': {
        marginRight: pxToRem(10),
    },
});

export const CTAButtonContainer: StyleRule<{ pageType: CTAHeaderType }> = ({
    theme,
    pageType,
}) => ({
    color: theme.siteVariables.colors.grey[300],
    display: 'flex',
    flexFlow: 'column',
    justifyItems: 'center',
    marginBottom: pageType === 'Article' ? pxToRem(16) : 0,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: pageType === 'Article' ? pxToRem(16) : 0,
    '> *:not(:first-child)': {
        marginTop: pxToRem(8),
        marginLeft: 0,
    },
    [theme.screen.tablet]: {
        justifyContent: 'end',
        marginRight: pageType === 'Article' ? pxToRem(52) : 0,
        flexFlow: 'row',
        '> *:not(:first-child)': {
            marginTop: 0,
            marginLeft: pxToRem(8),
        },
    },
});

export const CTAActionButtons: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        height: '100%',
        [`& .${buttonClassName} `]: {
            height: 'inherit',
        },
    },
});

export const HeaderButton: StyleRule = ({ theme }) => ({
    [`&.${buttonClassName}`]: {
        padding: pxArrayToRem([8, 20]),
        width: '100%',
        border: 'none',
        outline: `1px solid ${theme.siteVariables.colors.charcoal['250']}`,

        [`& .${labelClassName}`]: {
            textTransform: 'uppercase',
            fontSize: pxToRem(15),
            lineHeight: pxToRem(32),
            ...theme.siteVariables.textStyles.Heading.Medium65,
        },

        '&:hover': {
            border: 'none',
        },
    },
});
